import SimpleBar from "simplebar";
import ShrMapFactory from "./map-factory";

const initAllFiltrableMaps = () => {
  const filtrableMapEls = document.querySelectorAll(".js-filtrable-map-section-wrapper");
  filtrableMapEls.forEach((el) => {
    const { mapConfig } = el.dataset;
    const locations = el.dataset.markers;
    const { filters } = el.dataset;

    const data = {
      locations: JSON.parse(locations),
      filters: JSON.parse(filters),
    };

    // eslint-disable-next-line no-use-before-define
    const map = new ShrFiltrableMap(el, mapConfig, data);
    map.init();
  });
};

// Map to show locations from specific region
class ShrFiltrableMap {
  /**
   * constructor description
   * @param {string | HTMLElement} sectionWrapperEL Unique section class selector or HTMl element
   * @param {string | object} mapConfig Object containing desktop and mobile Google Maps configs
   * @param {string | object} data Object containing: locations[], filters[]
   */
  constructor(sectionWrapperEL, mapConfig, data) {
    this.sectionWrapperEL = typeof sectionWrapperEL === "string" ? document.querySelector(sectionWrapperEL) : sectionWrapperEL;
    this.filtersEl = this.sectionWrapperEL.querySelector(".js-map-filter-dropdown-wrapper");
    this.listEl = this.sectionWrapperEL.querySelector(".js-map-list-wrapper");
    this.mapEl = this.sectionWrapperEL.querySelector(".js-filtrable-map-wrapper");
    this.mapConfig = typeof mapConfig === "string" ? JSON.parse(mapConfig) : mapConfig;
    this.data = typeof data === "string" ? JSON.parse(data) : data;
    this.loading = false;
    this.activeFilters = [];
    this.submitBtn = this.filtersEl.querySelector(".js-filter-submit");
    this.resetBtn = this.filtersEl.querySelector(".js-filter-reset");
    this.toggleFilterBtn = this.filtersEl.querySelector("[data-bs-target='.js-map-filter-dropdown']");
    this.mapFactory = new ShrMapFactory(this.mapEl, this.mapConfig, { locations: this.data.locations }, 'filtrable');
    this.isMobile = window.matchMedia("(max-width: 1023px)").matches;
    this.tabs = null;
    this.counterEls = this.sectionWrapperEL.querySelectorAll(".js-map-filter-counter");
  }

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      // if ((this.isMobileMap && !this.isMobile) || (!this.isMobileMap && this.isMobile)) {
      //   /* Don't initialize the map on opposite breakpoint */
      //   return;
      // }

      if (!this.filtersEl || !this.listEl || !this.mapEl || !this.mapConfig || !this.data) {
        return { error: "Missing required parameters" };
      }

      if (this.isMobile) {
        this.filtersEl = this.sectionWrapperEL.querySelector(".map-filter-modal-wrapper .js-map-filter-dropdown-wrapper");
        this.submitBtn = this.filtersEl.querySelector(".js-filter-submit");
        this.resetBtn = this.filtersEl.querySelector(".js-filter-reset");
        this.toggleFilterBtn = this.filtersEl.querySelector(".js-map-filter-close");
        this.tabs = {
          listBtn: this.sectionWrapperEL.querySelector(".js-map-list-tab"),
          mapBtn: this.sectionWrapperEL.querySelector(".js-map-map-tab"),
        };
      }

      this.seedFilterOptions();
      this.seedLocationsList();
      this.initMap();

      this.submitBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.submitFilters();
      });

      this.resetBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.resetFilters();
      });

      return "init";
    });
  }

  seedFilterOptions() {
    const ulEl = this.filtersEl.querySelector("ul");
    const { filters } = this.data;

    if (!filters.length) {
      return { error: "Missing filters data" };
    }

    let html = "";

    filters.forEach((filter) => {
      const item = `
            <li class="form-check">
                <input class="form-check-input kazipot desktop get-input-value" type="checkbox" id="${filter.category}" />
                <label class="form-check-label" for="${filter.category}">${filter.label}</label>
            </li>
            `;

      html += item;
    });

    ulEl.innerHTML = html;

    return "seedFilterOptions";
  }

  seedLocationsList(locationsOverride) {
    const el = this.listEl;
    let locations;
    if (locationsOverride) {
      locations = locationsOverride;
    } else {
      locations = this.data.locations;
    }

    if (!locations.length) {
      return { error: "Missing filters data" };
    }

    let html = "";

    locations.forEach((location) => {
      const item = `
                <div class="content-item">
                    <button type="button" data-target-id="${location.id}" data-target-category="${location.category}" data-target-lat="${location.lat}" data-target-lng="${location.lng}"><img src="${location.icon}" alt="${location.info}" /> ${location.info} </button>
                </div>
            `;

      html += item;
    });

    el.innerHTML = html;
    const simpleBar = new SimpleBar(el);
    simpleBar.getContentElement();

    const buttons = el.querySelectorAll("button");
    buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const id = button.getAttribute("data-target-id");
        // eslint-disable-next-line eqeqeq
        const locationData = this.data.locations.find((location) => location.id == id);

        this.mapFactory.centerMapToMarker(locationData, 18, true);

        /* Switch tab to map if mobile */
        if (this.isMobile) {
          this.tabs.mapBtn.click();
        }
      });
    });

    return "seedLocationsList";
  }

  initMap() {
    const map = async () => this.mapFactory.init();
    return map();
  }

  submitFilters() {
    const checkboxes = this.filtersEl.querySelectorAll("input[type=checkbox]");

    this.activeFilters = Array.from(checkboxes).filter((checkbox) => checkbox.checked);

    this.updateList();
    this.updateCounter();

    this.toggleFilterBtn.click();
  }

  resetFilters() {
    if (!this.activeFilters.length) {
      const checkboxes = this.filtersEl.querySelectorAll("input[type=checkbox]");
      checkboxes.forEach((c) => {
        const checkbox = c;
        checkbox.checked = false;
      });
    } else {
      this.activeFilters.forEach((c) => {
        const checkbox = c;
        checkbox.checked = false;
      });

      this.activeFilters = [];

      this.updateList();
    }

    this.updateCounter();

    this.mapFactory.map.setZoom(this.mapConfig[this.isMobile ? "mobile" : "desktop"].zoom);
    this.mapFactory.map.panTo({
      lat: this.mapConfig[this.isMobile ? "mobile" : "desktop"].center.lat,
      lng: this.mapConfig[this.isMobile ? "mobile" : "desktop"].center.lng,
    });
  }

  updateCounter() {
    this.counterEls.forEach((el) => {
      const element = el;
      if (this.activeFilters.length) {
        element.textContent = `(${this.activeFilters.length})`;
      } else {
        element.textContent = "";
      }
    });
  }

  updateList() {
    let idArr;
    let locations;

    if (this.activeFilters.length) {
      idArr = this.activeFilters.map((checkbox) => checkbox.id);
      locations = this.data.locations.filter((location) => idArr.includes(location.category));
    } else {
      locations = this.data.locations;
    }

    this.seedLocationsList(locations);
    this.mapFactory.toggleMarkers(locations.map((location) => location.category));
  }
}

export { ShrFiltrableMap, initAllFiltrableMaps };
